module.exports = __webpack_public_path__ + "img/other_cluster_agriculture_100px_bluebox.ca7475ea.png";